import { useNavigation } from '@refinedev/core';
import { List, useTable } from '@refinedev/antd';
import { Table, Select, Space, Tag, Button } from 'antd';
import { EyeOutlined } from '@ant-design/icons';

interface Ticket {
  id: number;
  subject: string;
  status: 'OPEN' | 'IN_PROGRESS' | 'RESOLVED' | 'CLOSED';
  createdAt: string;
  user: {
    fullName: string;
    phone: string;
  };
}

export const SupportTicketList = () => {
  const { show } = useNavigation();

  const { tableProps } = useTable<Ticket>({
    resource: 'admin/tickets',
    syncWithLocation: true,
  });

  const statusLabels: Record<string, string> = {
    OPEN: 'Ochiq',
    IN_PROGRESS: 'Jarayonda',
    RESOLVED: 'Hal qilingan',
    CLOSED: 'Yopilgan',
  };

  const statusColors: Record<string, string> = {
    OPEN: 'red',
    IN_PROGRESS: 'orange',
    RESOLVED: 'green',
    CLOSED: 'default',
  };

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 80,
    },
    {
      title: 'Mavzu',
      dataIndex: 'subject',
      key: 'subject',
    },
    {
      title: 'Foydalanuvchi',
      dataIndex: 'user',
      key: 'user',
      render: (user: Ticket['user']) => (
        <div>
          <div>{user?.fullName || 'Ismi yo\'q'}</div>
          <div style={{ color: '#7F8C8D', fontSize: 12 }}>{user?.phone}</div>
        </div>
      ),
    },
    {
      title: 'Holat',
      dataIndex: 'status',
      key: 'status',
      render: (status: string) => (
        <Tag color={statusColors[status]}>{statusLabels[status] || status}</Tag>
      ),
    },
    {
      title: 'Sana',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (date: string) => new Date(date).toLocaleDateString('uz-UZ'),
    },
    {
      title: 'Amallar',
      key: 'actions',
      render: (_: unknown, record: Ticket) => (
        <Button
          type="text"
          icon={<EyeOutlined />}
          onClick={() => show('admin/tickets', record.id)}
        />
      ),
    },
  ];

  return (
    <List
      title="Murojatlar"
      headerButtons={
        <Space>
          <Select
            placeholder="Holat"
            allowClear
            style={{ width: 140 }}
            options={Object.entries(statusLabels).map(([value, label]) => ({
              value,
              label,
            }))}
          />
        </Space>
      }
    >
      <Table {...tableProps} columns={columns} rowKey="id" />
    </List>
  );
};
